/**
 * Footer
 */

export default function Footer() {
    const selectors = {
        'toggleScroll2Top' : '.js-scroll-top',
    };

    const contactMessageBox = jQuery('.contact-message-box');
    const achievementSlider = jQuery('.achievements-slider');

    this.init = () => {
        this.scroll2Top();
        this.toggleContactMessageBox();
        this.achievementsSlider();
        this.toggleMenuFooter();
        this.addRefForExternalLinks();
        this.setCookieConsent();
    };

    this.scroll2Top = () => {
        jQuery(selectors.toggleScroll2Top).on('click', (e)=>{
            e.preventDefault();
            jQuery("html, body").animate({
                scrollTop: 0
            }, "slow");
            return false;
        })

        jQuery(window).on('scroll', () => {
            let top = jQuery(window).scrollTop();
            if(top > 100){
                jQuery(selectors.toggleScroll2Top).fadeIn();
            }else{
                jQuery(selectors.toggleScroll2Top).fadeOut();
            }
        })
    }

    this.achievementsSlider = () => {
        achievementSlider.slick({
            accessibility: true,
            focusOnSelect: true,
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 800,
            speed: 800,
            slidesToShow: 10,
            slidesToScroll: 3,
            arrows: false,
            responsive: [
                {
                    breakpoint: 1440,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                }
            ]
        });
    }

    this.toggleMenuFooter = () => {
        jQuery('.footer-menu .menu-item-has-children > a').on('click', function (event) {
            event.preventDefault();
            jQuery(this).parent().toggleClass('active');
            jQuery(this).parent().find('.sub-menu').slideToggle(500);
        });
    }

    this.toggleContactMessageBox = () => {
        contactMessageBox.on('click', function () {
            jQuery(this).find('.contact-message-list').toggleClass('show');
        })
    }

    this.addRefForExternalLinks = () => {
        jQuery('body a').each(function () {
            const link = jQuery(this).attr('href');
            const rel = jQuery(this).attr('rel');
            if (link && !link.includes(location.hostname) && link.startsWith('http')) {
                if (rel) {
                    if (!rel.includes('dofollow')) {
                        jQuery(this).attr('rel', rel + ' nofollow');
                    }
                } else {
                    jQuery(this).attr('rel', 'nofollow');
                }
            }
        });
    }

    this.setCookieConsent = () => {
        const setCookie = (name, value, days) => {
            const currentDay = new Date();
            currentDay.setTime(currentDay.getTime() + (days * 24 * 60 * 60 * 1000));
            const expires = "expires=" + currentDay.toUTCString();
            document.cookie = `${name}=${value};${expires};path=/`;
        };

        const handleConsent = (value) => {
            setCookie('cookie_notice_accepted', value, 180);
            jQuery('#cookie-consent-block').remove();
        };

        // Event listeners for accept and reject buttons
        jQuery('.cookie-consent-accept').on('click', () => handleConsent(true));
        jQuery('.cookie-consent-deny').on('click', () => handleConsent(false));
    };


}
